import $ from 'jQuery';


import submitForm from './modules/submit-form';
import cookies from './modules/cookies';
import Animation from './modules/animation';
import Preloader from './modules/preloader';
import Header from './modules/header';
import ScrollLink from './modules/scroll-link';


import 'styles/less/application';


$(document).ready(() => {
  submitForm.init();
  cookies.init();
  Preloader.init();
  Animation.init();
  Header.init();
  ScrollLink.init();
});



// WEBPACK FOOTER //
// ./src/static/js/main.js